
import { reactive, toRefs, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { goodsquery } from '@/api/goods/index'
import { useStore } from '@/store/index.ts'
export default ({
  name: 'goodsquery',
  setup () {
    const state = reactive({
      goodslist: [],
      jsm: '',
      pm: '',
      loading: false
    })
    const store = useStore()
    const search = async () => {
      state.loading = true
      const goodslist = await goodsquery({ filterstring: state.jsm, cgy: getUserInfos.value.userName })
      state.goodslist = JSON.parse(JSON.stringify(goodslist))
      console.log(state.goodslist)
      state.loading = false
      ElMessage.success('查询成功')
    }
    const getUserInfos = computed(() => {
      return store.state.userInfos.userInfos
    })
    return {
      search,
      getUserInfos,
      ...toRefs(state)
    }
  }
})
